define('bindingHandlers/composer/formEditorWeight',[ 
    'lib/knockout', 
    'jquery', 
    'util/keyCode' 
], function (ko, $, KEY) { 
    'use strict'; 
 
    var EVENT_NAMESPACE = ".formEditorWeight-evt"; 
     
    /** 
     * A binding handler for controlling the weights of each question group. This should be used in surveys and evaluations only. 
     * 
     * # Required Arguments 
     * 
     * @param {Function} select - A function that will be called to select the question group 
     * @param {Function} unselect - A function that will be called to unselect the question group 
     * @param {Function} setManualWeight - A function that will be called to indicate that the user has set this question group's weight manually 
     * 
     * # Example 
     * 
     *      <span data-bind=" 
     *          formEditorWeight: { 
     *              select: select, 
     *              unselect: unselect, 
     *              setManualWeight: setManualWeight 
     *          } 
     *      "></span> 
     * 
     */ 
    ko.bindingHandlers.formEditorWeight = { 
        init: function(element, valueAccessor) { 
 
            var params = valueAccessor(); 
            var $element = $(element); 
 
            function focusWeight() { 
                params.select(); 
                params.setManualWeight(); 
            } 
 
            $element.on("click" + EVENT_NAMESPACE, function() { 
                $(element).focus(); 
            }); 
 
            $element.on("focus" + EVENT_NAMESPACE, function() { 
                focusWeight(); 
            }); 
 
            $element.on("keydown" + EVENT_NAMESPACE, function(e) { 
                if (e.keyCode === KEY.ENTER) { 
                    e.preventDefault(); 
                    params.unselect(); 
                } 
            }); 
 
            ko.utils.domNodeDisposal.addDisposeCallback(element, function () { 
                $element.off(EVENT_NAMESPACE); 
            }); 
        } 
    }; 
}); 
